import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
import { dictionary } from '../lib/content';
export function Timeline() {
  const {
    lang,
    t
  } = useI18n();
  const items = dictionary[lang].timeline.items;
  return <section className="w-full bg-white py-32 px-6 md:px-12 border-t border-black/[0.06]" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-display text-4xl md:text-5xl text-[#0A0A0F] mb-20 tracking-tight" data-id="element-204">
          {t('timeline.title')}
        </motion.h2>

        <div className="relative" data-id="element-205">
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-black/[0.08]" aria-hidden="true" data-id="element-206" />

          <ul className="space-y-16" data-id="element-207">
            {items.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.6,
            delay: i * 0.05
          }} className={`relative pl-10 md:pl-0 md:grid md:grid-cols-2 md:gap-12 ${i % 2 === 0 ? '' : 'md:[&>div:first-child]:col-start-2'}`} data-id="element-208">
                <div className={i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:pl-12'} data-id="element-209">
                  <div className="text-xs font-mono tracking-widest text-violet-electric mb-2" data-id="element-210">
                    {item.year}
                  </div>
                  <h3 className="text-xl text-[#0A0A0F] font-medium mb-2" data-id="element-211">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#4A4A55] leading-relaxed" data-id="element-212">
                    {item.desc}
                  </p>
                </div>
                <span className="absolute left-0 md:left-1/2 top-1 w-2.5 h-2.5 -translate-x-1/2 rounded-full bg-violet-electric ring-4 ring-violet-100" aria-hidden="true" data-id="element-213" />
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}